import * as React from "react";
const SvgProfile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#89909D"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.628 5.873a1 1 0 0 0-.2 0A2.677 2.677 0 0 1 1.842 3.19c0-1.485 1.2-2.69 2.69-2.69a2.687 2.687 0 0 1 .097 5.373M1.6 8.108c-1.466.982-1.466 2.58 0 3.556 1.665 1.115 4.397 1.115 6.063 0 1.466-.981 1.466-2.58 0-3.556C6.003 7 3.271 7 1.599 8.108"
    />
  </svg>
);
export default SvgProfile;
